import { FlowType } from '../components/start/flow-type.enum';
import { brazeUserTrack } from '../lib/braze';
import { Data, post } from '../networking';
import { refreshUserAndStoreIn } from './auth';

async function postUser(payload?: Data): Promise<Data> {
    return await post('auth/createUser', payload);
}

export function findCardinalityHelper(field: any, ref: string, cardinality: number[]): number[] {
    if (!field || !field.properties || !field.properties.fields) {
        return undefined;
    }

    const childFields = field.properties.fields;

    for(let i = 0; i < childFields.length; i++) {
        const childField = childFields[i];
        if(childField.type === 'group') {
            const foundCardinality = findCardinalityHelper(childField, ref, [...cardinality, i]);
            if (foundCardinality) {
                return foundCardinality;
            }
        }

        if (childField.ref === ref) {
            return [...cardinality, i];
        }
    }

    return undefined;
}

/**
 * Returns cardinality of ref. Returns undefined if not found.
 * @param rootField 
 * @param ref - refId to look for
 * @returns array representation of cardinality
 */
export function findCardinalityOn(rootField: any, ref: string): number[] {
    return findCardinalityHelper(rootField, ref, []);
}

export function preloadImages(images: string[]) {
    /* Preloading images are a nice to have - one by one to only occupy one thread at a time */
    images.reduce((p, i) => p.then(() => fetch(i)), Promise.resolve());
}

export async function createUserOrError(formId, session, cookies, appUserAgent, isPremiumPath) {
    const user: Data = {};
    if (cookies.utm_content && cookies.utm_source) {
        switch (cookies.utm_source) {
        case 'invite': {
            user.referredBy = cookies.utm_content;
            user.referralType = 'user';
            break;
        }
        case 'ambassador': {
            user.referredBy = cookies.utm_content;
            user.referralType = cookies.utm_source;
            break;
        }
        }
    }
    if (cookies?.ss_app_device || appUserAgent?.isApp) {
        user.create_source = cookies?.ss_app_device || appUserAgent.os;
    }
    if (cookies?.ss_app_is_production) {
        user.isProduction = cookies?.ss_app_is_production;
    }
    if (isPremiumPath) {
        user.flowType = FlowType.PREMIUM;
    }
    user.formId = formId;
    // TODO: remove once DJ challenge is off
    if (formId === 'UxjYeXGO') {
        user.flowType = FlowType.DRYJAN2024;
    }

    const userPostResponse = await postUser(user);
    // Properly check user creation and request token
    if (userPostResponse.id) {
        await refreshUserAndStoreIn(session);
        await brazeUserTrack({
            attributes: [
                { utm_content: cookies?.utm_content ?? null },
                { utm_source: cookies?.utm_source ?? null },
                { utm_medium: cookies?.utm_medium ?? null },
                { flow_type: user.flowType as string ?? null },
            ]
        });
        return true;
    } else {
        return false;
    }
}
